import { useState, useEffect } from "react";
import { database } from "./firebase";
import { collection, getDocs, query, where, getCountFromServer } from "firebase/firestore";

function AdminDownloadFiles() {
    const [wordsWithoutAudioCount, setWordsWithoutAudioCount] = useState(0);
    const [wordsWithoutAudioWords, setWordsWithoutAudioWords] = useState(0);

    // загрузка данных из файла
    const [jsonContentWordBase, setJsonContentWordBase] = useState([]);

    const onChangeFileWordBase = async (e) => {
        if (e.target.files && e.target.files[0]) {
        //   const updatedJSON = e.target.files[0];
        //   console.log(updatedJSON);
            const fileReader = new FileReader();
            fileReader.readAsText(e.target.files[0], "UTF-8");
            fileReader.onload = e => {
            // console.log("e.target.result", e.target);
            const target = e.target;
            const result = target?.result;
            var myObject = JSON.parse(result);
            var array = [];
            for (var key in myObject) {
                var item = myObject[key];
                array.push(item);
            }

            setJsonContentWordBase(array);
        }
    }};

    function processWords(e) {
        e.preventDefault();
        var modifiedArray = [];
        var wordsWithoutAudioArray = [];
        var withoutAudio = 0;
        var wordsCount = jsonContentWordBase.length + 1;
        var newObject = {};
        jsonContentWordBase.forEach((element) => {
            var objectInside = {};
            if(element.phrase) {
                objectInside.id = `wordID_${wordsCount}`;
                wordsCount += 1;
            } else {
                objectInside.id = element.id;
            }
            if(element.word) {
                objectInside.wordOrPhrase = element.word;
            } else if(element.phrase) {
                objectInside.wordOrPhrase = element.phrase;
            } else {
                objectInside.wordOrPhrase = "ERROR!";
            };
            if(element.type) {
                objectInside.type = element.type;
            }else{
                objectInside.type = "";
            };
            if(element.style) {
                objectInside.style = element.style;
            }else{
                objectInside.style = "";
            };
            if(element.reflexive === "yes") {
                objectInside.isPronominalVerb = true
            } else if (element.reflexive === "no") {
                objectInside.isPronominalVerb = false
            } else {
                objectInside.isPronominalVerb = false
            };
            if(element.verbtype === "irregular") {
                objectInside.isRegularVerb = false
            } else if (element.verbtype === "regular") {
                objectInside.isRegularVerb = true
            } else {
                objectInside.isRegularVerb = false
            };
            objectInside.engTranslation = Object.values(element.engtranslation);
            objectInside.rusTranslation = Object.values(element.rustranslation);
            objectInside.topics = Object.values(element.topics);
            if(element.hasaudioargentino === "yes") {
                objectInside.hasAudioArgentino = true;
            } else if(element.hasaudioargentino === "no") {
                objectInside.hasAudioArgentino = false;
            } else {
                objectInside.hasAudioArgentino = false;
            };
            if(element.gender) {
                objectInside.gender = element.gender;
            }else{
                objectInside.gender = "";
            };
            let arrayOfFlags = Object.values(element.country);
            let newArrayOfFlags = arrayOfFlags.map(item => {
                let newItem = item.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
                return newItem;
            });
            objectInside.countries = newArrayOfFlags;
            if(element.example) {
                objectInside.example = element.example;
            }else{
                objectInside.example = "";
            };
            if(element.example_tenses) {
                objectInside.exampleTenses = Object.values(element.example_tenses);
            } else {
                objectInside.exampleTenses = [""];
            };
            if(element.example_eng) {
                objectInside.engExample = element.example_eng;
            } else {
                objectInside.engExample = "";
            };
            if(element.example_rus) {
                objectInside.rusExample = element.example_rus;
            } else {
                objectInside.rusExample = "";
            };
            if(element.explanation_eng) {
                objectInside.engExplanation = element.explanation_eng;
            } else {
                objectInside.engExplanation = "";
            };
            if(element.explanation_rus) {
                objectInside.rusExplanation = element.explanation_rus;
            } else {
                objectInside.rusExplanation = "";
            };
            if(element.eng_analog) {
                objectInside.engAnalog = element.eng_analog;
            } else {
                objectInside.engAnalog = "";
            };
            if(element.rus_analog) {
                objectInside.rusAnalog = element.rus_analog;
            } else {
                objectInside.rusAnalog = "";
            };
            if(element.noungenders) {
                objectInside.nounGenders = element.noungenders;
            }else{
                objectInside.nounGenders = "";
            };
            if(element.adjgenders) {
                objectInside.adjGenders = element.adjgenders;
            }else{
                objectInside.adjGenders = "";
            };
            if(element.presenteDeIndicativo) {
                objectInside.presenteDeIndicativo = element.presenteDeIndicativo;
            } else {
                objectInside.presenteDeIndicativo = "";
                
            };
            if(element.preterito) {
                objectInside.preteritoPerfectoSimple = element.preterito;
            } else {
                objectInside.preteritoPerfectoSimple = "";
            };
            if(element.preteritoPerfecto) {
                objectInside.preteritoPerfecto = element.preteritoPerfecto;
            } else {
                objectInside.preteritoPerfecto = "";
            };
            if(element.imperfectodeIndicativo) {
                objectInside.preteritoImperfecto = element.imperfectodeIndicativo;
            } else {
                objectInside.preteritoImperfecto = "";
            };
            if(element.futurodeIndicativo) {
                objectInside.futuroDeIndicativo = element.futurodeIndicativo;
            } else {
                objectInside.futuroDeIndicativo = "";
            };
            if(element.imperativoAfirmativo) {
                objectInside.imperativoAfirmativo = element.imperativoAfirmativo;
            } else {
                objectInside.imperativoAfirmativo = "";
            };
            if(element.imperativoNegativo) {
                objectInside.imperativoNegativo = element.imperativoNegativo;
            } else {
                objectInside.imperativoNegativo = "";
            };
            if(element.presenteDeSubjuntivo) {
                objectInside.presenteDeSubjuntivo = element.presenteDeSubjuntivo;
            } else {
                objectInside.presenteDeSubjuntivo = "";
            };
            if(element.imperfectoDeSubjuntivo) {
                objectInside.imperfectoDeSubjuntivo = element.imperfectoDeSubjuntivo;
            } else {
                objectInside.imperfectoDeSubjuntivo = "";
            };
            
            if (objectInside.countries.includes("Argentina") && objectInside.hasAudioArgentino == false) {
                withoutAudio += 1;
                wordsWithoutAudioArray.push(objectInside.wordOrPhrase)
            }

            // скачивание всех Аргентинских слов с английским и русским переводом
            // if (objectInside.countries.includes("Argentina")) {
            //     withoutAudio += 1;
            //     wordsWithoutAudioArray.push(objectInside.wordOrPhrase + " - " + objectInside.engTranslation.join(", ") + " (" + objectInside.rusTranslation.join(", ") + ")")
            // }

            modifiedArray.push(objectInside);
        });
        setWordsWithoutAudioCount(withoutAudio);
        setWordsWithoutAudioWords(wordsWithoutAudioArray);
        // const result = countWordsByCountry(modifiedArray);
        // setUpdatesWordBase(result);
        console.log(modifiedArray);
    };


    // const [serverContentWords, setServerContentWords] = useState([]);
    

    // const getServerDataWords = async () => {
    //     var array = [];
    //     const querySnapshot = await getDocs(collection(database, "Words"));
    //     querySnapshot.forEach((doc) => {
    //         array.push(doc.data());
    //         // console.log(doc.id, " => ", doc.data());
    //     })
    //     // console.log(array)
    //     setServerContentWords(array);
    // };

    // const getCount = async () => {
    //     const q = query(collection(database, "Words"), where("hasAudioArgentino", "==", false),
    //     where("countries", "array-contains", "Argentina"));
    //     const snapshot = await getCountFromServer(q);
    //     console.log("Total count of matching documents: ", snapshot.data().count);
    //     setWordsWithoutAudioCount(snapshot.data().count)
    // };

    // const downloadTxtFile = () => {
    //     // console.log(serverContentWords)
    //     const element = document.createElement("a");
    //     const fileContent = serverContentWords
    //     .filter(word => word.hasAudioArgentino === false)
    //     .map(word => word.wordOrPhrase).join('\n');
        
    //     const file = new Blob([fileContent], { type: 'text/plain' });
    //     element.href = URL.createObjectURL(file);
    //     element.download = "wordsWithoutAudio.txt";
        
    //     document.body.appendChild(element);
    //     element.click();
    //     document.body.removeChild(element);
    // };
    const downloadTxtFile = () => {
        // console.log(serverContentWords)
        const element = document.createElement("a");
        const fileContent = wordsWithoutAudioWords.join('\n');
        
        const file = new Blob([fileContent], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = "wordsWithoutAudio.txt";
        
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    // useEffect(() => {
    //     if (wordsWithoutAudioWords.length > 0) {
    //         downloadTxtFile();  // Вызывается после обновления serverContentWords
    //     }
    // }, [wordsWithoutAudioWords]);

    // Вызов функции для загрузки данных с сервера и создания файла
    // const handleDownload = async () => {
    //     await getServerDataWords();
    // };

    // скачивание json references
    // function downloadJSON(data, fileName) {
    //     const jsonString = JSON.stringify(data, null, 2);
    //     const blob = new Blob([jsonString], { type: "application/json" });
    //     const link = document.createElement("a");
    //     link.href = URL.createObjectURL(blob);
    //     link.download = `${fileName}.json`;
    //     link.click();
    // };

    // async function fetchFirestoreDataJson() {
    //     try {
    //       const querySnapshot = await getDocs(collection(database, "references"));
    //       const data = [];
    //       querySnapshot.forEach((doc) => {
    //         data.push({ id: doc.id, ...doc.data() });
    //       });
    //       return data;
    //     } catch (error) {
    //       console.error("Error fetching Firestore data:", error);
    //       throw error;
    //     }
    // };

    // const handleDownloadJson = async () => {
    //     try {
    //     const data = await fetchFirestoreDataJson();
    //     downloadJSON(data, "references-data");
    //     } catch (error) {
    //     console.error("Error downloading data:", error);
    //     }
    // }

    return (
        <div className="w-full mt-24">
            <div className="flex items-center flex-col">
                {/* <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-1/3">
                    <div className="flex flex-row justify-between">
                    <h1 className="text-center text-xl pb-2 font-bold">Слова без озвучки</h1>
                    <button onClick={getCount}>
                        <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 14 3-3m-3 3 3 3m-3-3h16v-3m2-7-3 3m3-3-3-3m3 3H3v3"/>
                        </svg>
                    </button>
                    </div>
                    <div>
                        Argentina: {wordsWithoutAudioCount}
                    </div>
                    <div className="flex flex-row justify-end">
                        <button onClick={handleDownload} className="bg-white p-2 rounded-lg hover:bg-green-500">Скачать</button>
                    </div>
                </div> */}

                <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-1/3">
                    <div className="flex flex-row justify-between">
                    <h1 className="text-center text-xl pb-2 font-bold">Слова без озвучки</h1>
                    </div>
                    <form className="flex flex-col space-y-2">
                        <input type="file" accept=".json" onChange={onChangeFileWordBase} />
                        <button onClick={processWords} className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Обработать</button>
                    </form>
                    <div>
                        Argentina: {wordsWithoutAudioCount}
                    </div>
                    <div className="flex flex-row justify-end">
                        <button onClick={downloadTxtFile} className="bg-white p-2 rounded-lg hover:bg-green-500">Скачать</button>
                    </div>
                </div>

                {/* <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-1/3">
                    <div className="flex flex-row justify-between">
                    <h1 className="text-center text-xl pb-2 font-bold">References</h1>
                    </div>
                    <div className="flex flex-row justify-end">
                        <button onClick={handleDownloadJson} className="bg-white p-2 rounded-lg hover:bg-green-500">Скачать</button>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default AdminDownloadFiles